// infrastructure/api/billingExportApi.js
import { callFirebaseFunction } from 'boot/firebase';

/**
 * Record that these items were exported, and mark them as such.
 *
 * A CALLABLE RATHER THAN A WRITE, because the rules give `billingItems` no client write path at all.
 * That is the design: an item is derived, so a browser write would be overwritten by the next
 * projection run. `exportState` and its timestamp are the one thing the projector does not own, and
 * the server sets them on the user's behalf.
 *
 * IT SENDS THE IDS THE FILE CONTAINED, not the filters they came from. The file in somebody's hands
 * is a specific set of rows, and a server re-running the filter could stamp a different set. What
 * the file covered travels too, but only as part of the audit record.
 *
 * @param {{clinicId: string, itemIds: string[], scope: Object}} request
 * @returns {Promise<{stamped: number, skipped: number, exportId: string}>}
 */
// eslint-disable-next-line import/prefer-default-export
export async function markBillingItemsExported({ clinicId, itemIds, scope }) {
  const { data } = await callFirebaseFunction('markBillingItemsExported', {
    clinicId,
    itemIds,
    scope,
  });

  return data;
} // markBillingItemsExported()
